import { Button } from 'react-bootstrap';
import classes from './BeanModal.module.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import Bean from '../../../components/Bean';
import { svg2png } from '../../../utils/svg2png';
import { Backdrop } from '../../../components/Modal';

const downloadBeanPNG = (png: string) => {
  const downloadEl = document.createElement('a');
  downloadEl.href = png;
  downloadEl.download = 'bean.png';
  downloadEl.click();
};

const BeanModal: React.FC<{ onDismiss: () => void; svg: string }> = (props) => {
  const { onDismiss, svg } = props;

  const [width, setWidth] = useState<number>(window.innerWidth);
  const [png, setPng] = useState<string | null>();

  const isMobile: boolean = width <= 991;

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    const loadPng = async () => {
      setPng(await svg2png(svg, 500, 500));
    };
    loadPng();

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [svg]);

  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop
          onDismiss={() => {
            onDismiss();
          }}
        />,
        document.getElementById('backdrop-root')!
      )}
      {ReactDOM.createPortal(
        <div className={classes.modal}>
          {svg && (
            <Bean
              imgPath={svg}
              alt='bean'
              className={classes.beanImg}
              wrapperClassName={classes.beanWrapper}
            />
          )}
          <div className={classes.displayBeanFooter}>
            <span>Use this Bean as your profile picture!</span>
            {!isMobile && png && (
              <Button
                onClick={() => {
                  downloadBeanPNG(png);
                }}
              >
                DOWNLOAD
              </Button>
            )}
          </div>
        </div>,
        document.getElementById('overlay-root')!
      )}
    </>
  );
};
export default BeanModal;
